export default "__VITE_ASSET__CixRvFKS__"